<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0">
      <div class="md-layout md-alignment-center">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0">
          <h1 class="title-h4-formatting">{{ this.headerData.title + ': ' }}</h1>
          <ul>
            <li>
              <p class="sub-title-formatting"><i class="md-icon md-icon-dark-blue">business_center</i>Industry: </p>
              <p>[{{ parseFloat(this.headerData.bznaics) }}] {{ this.headerData.industry }}</p>
            </li>
            <li>
              <p class="sub-title-formatting"><i class="md-icon md-icon-dark-blue">apartment</i>Sector: </p>
              <p>{{ this.headerData.sector }}</p>
            </li>
            <li>
              <p class="sub-title-formatting"><i class="md-icon md-icon-dark-blue">place</i>Market Area: </p>
              <p>{{ this.headerData.area }}</p>
            </li>
            <li>
              <p class="sub-title-formatting"><i class="md-icon md-icon-dark-blue">equalizer</i>Sales Class: </p>
              <p>{{ this.headerData.sales_class }}</p>
            </li>
          </ul>
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-40 md-size-40 button-box">
          <!-- Ask Bizminer (CHAT-12): same visibility rule as the top-bar button. -->
          <md-button v-if="chatVisible" class="md-info access-button pdf_btn ask-report-btn" :disabled="!reportContext"
            data-test="ask-about-report" @click="askAboutReport"><md-icon>forum</md-icon>Ask about this profile</md-button>
          <!-- CHAT-20: "What stands out?" runs only on this click, never on page load. -->
          <span v-if="insightsEntryState !== 'hidden' && insightsView && insightsView.kind === 'not_owned'" class="stands-out-note"
            data-test="stands-out-not-owned">What stands out? {{ insightsView.text }}</span>
          <md-button v-else-if="insightsEntryState !== 'hidden'" class="md-info access-button pdf_btn stands-out-btn"
            :class="{ 'is-locked': insightsEntryState === 'locked' }" :disabled="standsOutDisabled"
            :title="insightsEntryState === 'locked' ? 'Included with a Bizminer subscription' : ''"
            data-test="stands-out" @click="standsOut"><md-icon>{{ insightsEntryState === 'locked' ? 'lock' : 'auto_awesome' }}</md-icon>{{ insightsLoading ? 'Reading this report…' : 'What stands out?' }}</md-button>
          <span v-if="insightsEntryState === 'button' && insightsLimited && !showInsightsCard" class="stands-out-note"
            data-test="stands-out-limit">{{ insightsLimitText }}</span>
          <span v-else-if="insightsEntryState === 'button' && insightsUnverified && !showInsightsCard" class="stands-out-note"
            data-test="stands-out-unverified">{{ insightsView.text }}</span>
          <span v-else-if="insightsEntryState === 'button' && insightsIdentityState === 'missing'" class="stands-out-note"
            data-test="stands-out-unidentified">Couldn't identify this report.</span>
          <md-button class="md-info access-button pdf_btn" @click="feedback"><md-icon>comment</md-icon>Product Feedback</md-button>
          <md-button v-if="!profile || !profile.years" class="md-info access-button pdf_btn">
            <template><md-icon class="ml-5">picture_as_pdf</md-icon>Loading...</template>
          </md-button>
          <md-button v-if="pdfLoading" class="md-info access-button pdf_btn">
            <template><md-icon class="ml-5">picture_as_pdf</md-icon>Downloading...</template>
          </md-button>
          <md-button v-if="profile && profile.years && !this.pdfGenerating" target="_blank" class="md-info access-button pdf_btn" @click="downloadPDFDataAPI">
            <md-icon class="ml-5">picture_as_pdf</md-icon>
            Download PDF
          </md-button>
          <md-button v-if="this.pdfGenerating" :class="'md-info access-button pdf_btn'"><md-icon class="ml-5">picture_as_pdf</md-icon>Generating...</md-button>

          <md-button :class="!profile || !profile.years ? 'md-info access-button csv_btn disabled' : 'md-info access-button pdf_btn'" @click.native="downloadCSVData">
            <md-icon class="ml-5">receipt_long</md-icon>
            {{ (!profile || !profile.years) ? 'Loading...' : 'Download CSV' }}
          </md-button>
        </div>
        <div class="md-layout-item md-size-100" v-if="colouredLineChart"></div>
      </div>
    </div>
    <div v-if="showInsightsCard" class="md-layout-item md-size-100 stands-out-wrap">
      <insights-card :phase="insightsState.phase" :data="insightsState.data" :view="insightsState.view"
        @ask="askAboutInsight" @retry="standsOut" @hide="insightsOpen = false" />
    </div>
    <modal v-if="feedbackModal" @close="feedbackModal = false" class="feedback_modal">
      <template slot="body">
        <button type="button" class="close_btn" @click="feedbackModal = false">
          <md-icon>clear</md-icon>
        </button>
        <h3 class="modal-title">Have feedback on this product?</h3>
        <p>Enter the details below to send your feedback to our Product Team.</p>
        <form action class="form_grp">
          <div class="field_wpr">
            <label>Leave A Feedback Note</label>
            <textarea v-model="textFeedback" placeholder="Type a message"></textarea>
            <md-button @click="sendFeedback" class="md-info md-round mt-4">Send Feedback</md-button>
            <div class="md-layout-item">
              <md-checkbox v-model="checkBoxOption1">1 - Report An Error</md-checkbox>
              <md-checkbox v-model="checkBoxOption2" class="pl-3">2 - Suggest an Improvement</md-checkbox>
              <md-checkbox v-model="checkBoxOption3">3 - Request a Correction</md-checkbox>
              <md-checkbox v-model="checkBoxOption4">4 - Request an Update</md-checkbox>
            </div>
          </div>
        </form>
      </template>
    </modal>
    <IFPDF ref="ifPDF" :headerInfo="headerData" :information="{ tableDataFirmsAnalyzed, colouredLineChart, naicsDrilldown }" :valMultiples="{ multiplesA, multiplesB, multiplesC, multiplesAll }"/>
  </div>
</template>
<script>
import {Modal} from '@/components';
import {mapState, mapActions} from 'vuex';
import formatData from '@/mixins/format-data';
import IFPDF from './_partials/IFPDF.vue';
import axios from 'axios';
import { posthog } from '@/main';
import { buildReportContext, buildInsightsRequest, insightsIdentity, insightsEntry, insightsLocked, insightQuestion, INSIGHTS_LIMIT_TEXT } from '@/components/AskBizminer/chatCore';
import InsightsCard from '@/components/AskBizminer/InsightsCard.vue';

export default {
  components: {
    Modal,
    IFPDF,
    InsightsCard
  },
  mixins: [formatData],
  props: ['headerData'],
  created() {
    // Moving between the report's tabs: show the result already read, never ask again.
    this.syncInsightsOpen();
  },
  data() {
    return {
      checkBoxOption1: null,
      checkBoxOption2: null,
      checkBoxOption3: null,
      checkBoxOption4: null,
      category: null,
      feedbackModal: false,
      textFeedback: '',
      tableInfo: [
        {
          id: 'Low',
          name: 'Q1',
        },
        {
          id: 'Med',
          name: 'Median',
        },
        {
          id: 'High',
          name: 'Q3',
        },
      ],
      multiplesTableInfo: [
        {
          id: 'Low',
          name: 'Q1',
        },
        {
          id: 'Med',
          name: 'Median',
        },
        {
          id: 'High',
          name: 'Q3',
        },
      ],
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      naicsDrilldown: {},
      tableDataFirmsAnalyzed: [],
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: '',
      pdfFile: this.pdfFile || "/if_profile.pdf",
      pdfURL: null,
      pdfGenerating: false,
      insightsOpen: false // the "What stands out?" card is showing (set by the click, or on arrival when a result is already stored)
    };
  },
  computed: {
    chatVisible() {
      return this.$store.getters['chat/visible'];
    },
    // "What stands out?" (CHAT-20). Entry: hidden | locked | button, by the same rule as every chat entry point.
    insightsEntryState() {
      return insightsEntry({ visible: this.chatVisible, mode: this.$store.getters['chat/mode'] });
    },
    // pending | missing | stale | ok: is the loaded IF profile this page's report? (see insightsIdentity)
    insightsIdentityState() {
      return insightsIdentity({ profile: this.$store.state.user.profile, reportId: this.$route.params.id });
    },
    // The report's combination (bznaics, area_id, sale_class_id) from the page's own IF profile data, plus its id.
    // Null unless the profile's reportID is present and equal to the route's id.
    insightsRequest() {
      return buildInsightsRequest({ profile: this.$store.state.user.profile, reportId: this.$route.params.id });
    },
    // The daily limit answered for this report: the button stays off until the page reloads.
    insightsLimited() {
      return !!this.insightsState && this.insightsState.phase === 'error' && !!this.insightsState.view && !!this.insightsState.view.limited;
    },
    // The service could not verify this report (409 report_unverified): final for this report, same lock.
    insightsUnverified() {
      return !!this.insightsState && this.insightsState.phase === 'error' && !!this.insightsState.view && !!this.insightsState.view.unverified;
    },
    insightsLockedNow() {
      return insightsLocked(this.insightsState);
    },
    insightsLimitText() {
      return INSIGHTS_LIMIT_TEXT;
    },
    insightsKey() {
      return String(this.$route.params.id);
    },
    insightsState() {
      return this.$store.state.chat.insights[this.insightsKey] || null;
    },
    insightsView() {
      return this.insightsState && this.insightsState.phase === 'error' ? this.insightsState.view : null;
    },
    insightsLoading() {
      return !!this.insightsState && this.insightsState.phase === 'loading';
    },
    standsOutDisabled() {
      return this.insightsEntryState === 'button' && (this.insightsLoading || this.insightsLockedNow || !this.insightsRequest);
    },
    showInsightsCard() {
      const st = this.insightsState;
      if (!this.insightsOpen || this.insightsEntryState !== 'button' || !st) return false;
      return st.phase !== 'error' || !!(st.view && (st.view.kind === 'retry' || st.view.kind === 'message') && st.view.text);
    },
    // Context for Ask Bizminer, taken from the header band's own data. Null
    // while the header is still loading (headerData starts as []).
    reportContext() {
      return buildReportContext(this.headerData);
    },
    ...mapState({
      user: (state) => state.user.user,
      multiplesA: (state) => {
        return state.user.profile['multiples_A']
            ? state.user.profile['multiples_A']
            : [];
      },
      multiplesB: (state) => {
        return state.user.profile['multiples_B']
            ? state.user.profile['multiples_B']
            : [];
      },
      multiplesC: (state) => {
        return state.user.profile['multiples_B']
            ? state.user.profile['multiples_B']
            : [];
      },
      multiplesAll: (state) => {
        return state.user.profile['multiples_all']
            ? state.user.profile['multiples_all']
            : [];
      },
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      pdfLoading: (state) => state.user.pdfLoading,
      PLtable: (state) => state.user.profile.tables['PL'],
      BStable: (state) => state.user.profile.tables['BS'],
      tables: (state) => state.user.profile.tables['ratios'],
      tablesInfo: (state) => state.user.profile.tables['ratioInfo'],
      sourcesUses: (state) => state.user.profile['sourcesUses'],
      sourceYears: (state) => state.user.profile['sourcesUses']['years'],
      release_display: (state) => state.user.profile.release_display,
      bznaics_code: (state) => state.user.profile.bznaics,
      sector_name: (state) => state.user.profile.data[0].sector,
      industry_title: (state) => state.user.profile.data[0].industry,
      sales_class: (state) => state.user.profile.data[0].sales_class,
      display_area: (state) => state.user.profile.data[0].display_area,
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    getCsvData() {
      let csvData = [
        ['Industry Financial Profile'],
        ['"Release Date"', this.release_display],
        [''],
        ['Segment', 'Industry'],
        [this.industry_title],
        ['[' + parseInt(this.bznaics_code) + ']' + ' Sector', this.sector_name],
        ['Market', this.headerData.area],
        ['Sales Class', this.sales_class],
        [''],
      ];
      csvData.push(['Firms Analyzed', this.filtered_years]);
      csvData.push(['', this.filtered_firms]);
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss($)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss(%)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet($)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
        if (Array.isArray(e) && e[0] === 'Total Assets') {
          csvData.push(['Liabilities']);
        }
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet(%)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
        if (Array.isArray(e) && e[0] === 'Total Assets') {
          csvData.push(['Liabilities']);
        }
      });
      csvData.push(['']);
      csvData.push(['Financial Ratios: Cash Flow-Solvency']);
      csvData.push(['', this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Profitability']);
      csvData.push(['', this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Efficiency']);
      csvData.push(['', this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Debt-Risk']);
      csvData.push(['', this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Sources & Uses of Funds']);
      csvData.push(['', this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['Worksheet:']);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      // ------------------- Valuation -------------------------
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Valuation Multiples']);
      csvData.push(['Sales Group: < $2.5m:']);
      csvData.push(['', 'Sales Multiples', 'Earnings Multiples']);
      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([item.name, this.multiplesA[`Sales${item.id}`], this.multiplesA[`Earnings${item.id}`]]);
      });
      csvData.push(['']);
      csvData.push(['Sales Group: $2.5m - $24.9m:']);
      csvData.push(['', 'Sales Multiples', 'Earnings Multiples']);
      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([item.name, this.multiplesB[`Sales${item.id}`], this.multiplesB[`Earnings${item.id}`]]);
      });
      csvData.push(['']);
      csvData.push(['Sales Group: > $25m:']);
      csvData.push(['', 'Sales Multiples', 'Earnings Multiples']);
      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([item.name, this.multiplesC[`Sales${item.id}`], this.multiplesC[`Earnings${item.id}`]]);
      });
      csvData.push(['']);
      csvData.push(['Sales Group: All:']);
      csvData.push(['', 'Sales Multiples', 'Earnings Multiples']);
      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([item.name, this.multiplesAll[`Sales${item.id}`], this.multiplesAll[`Earnings${item.id}`]]);
      });
      return csvData;
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  watch: {
    // Another report: the card's open/closed state is that report's own, never carried over.
    '$route.params.id'() {
      this.syncInsightsOpen();
    },
    profile() {
      // this.parseCSVData();
      this.initData();
      //this.generatePDFData();
    },
    checkBoxOption1(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption2 = false;
        this.checkBoxOption3 = false;
        this.checkBoxOption4 = false;
        this.category = '1';
      }
    },
    checkBoxOption2(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption3 = false;
        this.checkBoxOption4 = false;
        this.category = '2';
      }
    },
    checkBoxOption3(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption2 = false;
        this.checkBoxOption4 = false;
        this.category = '3';
      }
    },
    checkBoxOption4(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption2 = false;
        this.checkBoxOption3 = false;
        this.category = '4';
      }
    }
  },
  mounted() {
    this.$store.commit('user/SET_PDF_LOADING', false);
    this.initData();
    posthog.capture('financial_profile_viewed', {
      industry: this.headerData?.industry,
      bznaics: this.headerData?.bznaics,
      area: this.headerData?.area,
      sales_class: this.headerData?.sales_class,
    });
  },
  methods: {
    ...mapActions({
      downloadPDFfromAPI: 'pdf/download',
      registerProductExport: 'tracking/registerProductExport',
    }),
    resetValues() {
      this.filtered_years = [];
      this.filtered_firms = [];
      this.filtered_PLDollar = [];
      this.filtered_PLPercent = [];
      this.filtered_BSDollar = [];
      this.filtered_BSPercent = [];
      this.cashflow = [];
      this.cashFlowFilteredData = [];
      this.efficiency = [];
      this.efficiencyFilteredData = [];
      this.profitability = [];
      this.profitabilityFilteredData = [];
      this.turnover = [];
      this.debtRiskFilteredData = [];
      this.changein = [];
      this.changeinFilteredData = [];
      this.worksheet = [];
      this.worksheetFilteredData = [];
      this.sales_class_csv = '';
    },
    initData() {
      if (!this.profile || !this.profile.years) {
        return;
      }
      this.resetValues();
      this.profile.years.forEach((e, i) => {
        //this.filtered_years.push(Number(e));
        this.filtered_years.push(e);
      });
      this.init();
      let firmData = Object.values(this.profile.data)
          .filter((item) => item)
          .map((item) => ({...item, firms: item.firms}));
      firmData.forEach((element) => {
        this.filtered_firms.push(parseFloat(element.firms));
      });
      this.filtered_firms.reverse();
      if (this.sales_class.includes(',')) {
        this.sales_class_csv = this.sales_class.replace(/,/, '');
      }
      let PLdollar = this.formatTable(this.PLtable, 'industry', 'dollar');
      let PLpercent = this.formatTable(this.PLtable, 'industry', 'percent');
      PLdollar.forEach((element) => {
        if (element.name.includes(',')) {
          element.name = element.name.replace(/,/g, '');
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollar.push(v);
      });
      PLpercent.forEach((element) => {
        if (element.name.includes(',')) {
          element.name = element.name.replace(/,/g, '');
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === 'string' && item.includes(',')) {
            item = parseFloat(item.replace(/,/g, ''));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercent.push(v);
      });
      let BSdollar = this.formatTable(this.BStable, 'industry', 'dollar');
      let BSpercent = this.formatTable(this.BStable, 'industry', 'percent');
      BSdollar.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_BSDollar.push(v);
      });
      BSpercent.forEach((element) => {
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === 'string' && item.includes(',')) {
            item = parseFloat(item.replace(/,/g, ''));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercent.push(v);
      });
      if (!_.isEmpty(this.tables)) {
        Object.entries(this.tables).forEach(
            ([table, data]) => this.$set(this, table, this.formatTable(data, 'industry'))
        );
      }
      let cashFlowData = [];
      this.cashflow.forEach((element, index) => {
        if (element.name in this.tables['cashflow']) {
          cashFlowData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      cashFlowData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.title);
        this.cashFlowFilteredData.push(v);
      });
      let efficiencyData = [];
      this.efficiency.forEach((element, index) => {
        if (element.name in this.tables['efficiency']) {
          efficiencyData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      efficiencyData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.title);
        this.efficiencyFilteredData.push(v);
      });
      let profitabilityData = [];
      this.profitability.forEach((element, index) => {
        if (element.name in this.tables['profitability']) {
          profitabilityData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      profitabilityData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.title);
        this.profitabilityFilteredData.push(v);
      });
      let debtRiskData = [];
      this.turnover.forEach((element, index) => {
        if (element.name in this.tables['turnover']) {
          debtRiskData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      debtRiskData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.title);
        this.debtRiskFilteredData.push(v);
      });
      Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
          this.$set(this, table, this.formatSourcesData(table, data))
      );
      this.changein.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.changeinFilteredData.push(k);
      });
      this.worksheet.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.worksheetFilteredData.push(k);
      });
    },
    sendFeedback() {
      if (this.category) {
        let currentSession = localStorage.getItem(
            "vue-authenticate.vueauth_access_token"
        );
        axios
            .post(
                process.env.VUE_APP_API_BASE_URL + '/user/feedback/submit',
                {},
                {
                  params: {
                    session_id: currentSession,
                    feedback: this.textFeedback,
                    url: `${window.location.href}`,
                    category: this.category
                  },
                }
            )
            .then((res) => {
              if (res.hasOwnProperty('data') && res.data.error) {
                this.$store.commit('SET_ERROR_BIT', true);
                this.$store.commit(
                    'SET_ERROR_INFO',
                    '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
                );
                throw new Error(
                    '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode
                );
              }
              if (res.data.success) {
                posthog.capture('feedback_submitted', { category: this.category, url: window.location.href });
                this.$store.dispatch('alerts/success', "Data saved.");
              } else
                this.$store.dispatch('alerts/error', "An error occured. please try again");
              this.feedbackModal = false;
              this.textFeedback = null;
              this.category = null;
              this.checkBoxOption1 = false;
              this.checkBoxOption2 = false;
              this.checkBoxOption3 = false;
              this.checkBoxOption4 = false;
            });
      } else {
        this.$store.commit('SET_ERROR_BIT', true);
        this.$store.commit(
            'SET_ERROR_INFO',
            '<br>' +
            'Server responded with error = True <br> errorCode: ' +
            'category_not_set' +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },
    init() {
      this.tableDataFirmsAnalyzed = Object.values(this.profile.data)
          .filter((item) => item)
          .map((item) => ({...item, firms: this.numberWithCommas(item.firms)}));
      this.tableDataFirmsAnalyzed = _.orderBy(
          this.tableDataFirmsAnalyzed,
          ['year'],
          ['asc']
      );
      this.naicsDrilldown = this.profile.naicsDrilldown;
      this.colouredLineChart.data = {
        labels: this.profile.years,
        series: [this.filteredProfile.map((item) => item.firms)],
      };
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    feedback() {
      this.feedbackModal = true;
    },
    askAboutReport() {
      if (this.reportContext) this.$store.dispatch('chat/openPanel', this.reportContext);
    },
    // The only trigger of POST /insights. Locked (teaser): open the panel, which shows the pitch.
    standsOut() {
      if (this.insightsEntryState === 'locked') {
        this.$store.dispatch('chat/openPanel', null);
        return;
      }
      if (this.insightsEntryState !== 'button' || !this.insightsRequest || this.insightsLockedNow) return;
      this.insightsOpen = true;
      this.$store.dispatch('chat/loadInsights', {
        key: this.insightsKey,
        request: this.insightsRequest,
        force: !!this.insightsState && this.insightsState.phase === 'error',
      });
    },
    // Closed, unless this report already has a result to show (never an error, which asks for a click).
    syncInsightsOpen() {
      this.insightsOpen = !!this.insightsState && this.insightsState.phase !== 'error';
    },
    // The insight's own follow-up question, sent in the panel about this report.
    askAboutInsight(insight) {
      const question = insightQuestion(insight);
      if (this.reportContext && question) this.$store.dispatch('chat/askAbout', { context: this.reportContext, question });
    },
    generatePDFData() {
      // PDF API generating
      let data = {};
      data.type = 'ifp';
      data.report = this.profile;
      this.$store.dispatch('pdf/download', data).then(async (res) => {
        this.pdfURL = res.pdf_data;
        this.pdfGenerating = false;
      });
    },
    downloadPDFData() {
      // PDF API download

      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: 'PDF'
      });

      if (this.$route.query.pdftest) {
        window.open('https://com-bizminer-application-fileupload.s3.amazonaws.com/pdfs/test.pdf', '_blank');
      } else {
        // PDF frontend download
        this.$store.commit('user/SET_PDF_LOADING', true);
        this.$refs.ifPDF.generateReport();
      }
    },
    downloadPDFDataAPI() {
      // PDF API download
      this.pdfGenerating = true;
      posthog.capture('pdf_downloaded', {
        report_type: 'industry_financial_profile',
        industry: this.headerData?.industry,
        bznaics: this.headerData?.bznaics,
        area: this.headerData?.area,
      });

      let data = {};
      data.type = 'ifp';
      data.report = this.profile;
      this.$store.dispatch('pdf/download', data).then(async (res) => {
        this.pdfGenerating = false;

        if(res.pdf_success) {
          window.open(res.pdf_data, '_blank');
        }
      });
    },
    downloadCSVData() {
      posthog.capture('csv_downloaded', {
        report_type: 'industry_financial_profile',
        industry: this.headerData?.industry,
        bznaics: this.headerData?.bznaics,
        area: this.headerData?.area,
      });
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Financial Profile.csv';
      anchor.click();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: 'CSV'
      })
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
          this.sourceYears.reduce((acc, cur, index) => {
            let value = this.actualData[this.sourceYears.length - index - 1][id];
            value = isNaN(Number(value)) ? value : Number(value.toFixed(0));
            return {...acc, [cur]: value};
          }, {});
      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.stands-out-wrap { padding: 0 !important; }
.stands-out-note { display: inline-block; margin: 0 6px; padding: 8px 12px; font-size: 12.5px; color: #3c4656; background: #f3f5f8; border-radius: 6px; }
.md-button.md-info.access-button.stands-out-btn {
  border-color: #003666;
  &.is-locked { opacity: 0.85; }
}

// The shared `.if-profile .button-box .access-button .md-ripple` rule paints the label and icon navy: on this navy pill they need to be white.
.if-profile .button-box .md-button.access-button.ask-report-btn .md-ripple,
.if-profile .button-box .md-button.access-button.ask-report-btn .md-ripple i {
  color: #fff !important;
}

// Phones: the button row is a 40% column; let it use the full width and wrap, so every button can be tapped.
@media (max-width: 600px) {
  .if-profile .button-box.md-layout-item {
    flex: 0 0 100%;
    max-width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 6px 0;
  }
}

.md-button.md-info.access-button.ask-report-btn {
  background-color: #003666 !important;
  border-color: #003666;
  color: #fff;

  &:hover:not([disabled]) {
    background-color: #002a50 !important;
  }
}
</style>
